module.exports = __webpack_public_path__ + "img/img_09.97b65c3e.png";